import * as _ from 'lodash'
import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset, IProfileFilter, ITree, ISearchSort, ISearchRenderOptions
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {
    ICubeSourceMetricId,
    ICubeSourceSearchMetricIdOptions
} from "../PA.HyperRectangle.Services/PA.HyperRectangle.Services.IF";
import {CubeSourceMetaDataService} from "../PA.HyperRectangle.Services/CubeSourceMetaDataService";


export interface IMetricIdSearchByListCreateOptions {
    sName: string,
    metricIds?: ICubeSourceMetricId[],
    wbCubeSourceId?: number,
    searchOptions?: ICubeSourceSearchMetricIdOptions
}

const vUI_MetricId_Search_Fields: {[id:string]: ISearchProviderField } = {

    MetricId:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric Id',      columnResourceName: 'colId',            alignment: HorizAlignment.Left}, domainOptions: {}},
    MetricName:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name',           columnResourceName: 'colName',          alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    GroupName:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Group',          columnResourceName: 'colGroup',         alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    TechnicalName: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Technical Name', columnResourceName: 'colTechnicalName', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50}},
    Comments:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Comments',       columnResourceName: 'colComments',      alignment: HorizAlignment.Left}, domainOptions: {maxLength: 1333}},
}


const   MetricId_keyFields_ByWBId =
    {  id:    'MetricId',
       id_ui: 'MetricId',
       name:  'MetricName'
    }


class MetricIdSearchByListSearchProvider
    implements  ISearchProvider {

    opts: IMetricIdSearchByListCreateOptions

    constructor(options: IMetricIdSearchByListCreateOptions){
        this.opts = options || {sName: "Unknown"}
    }

    get keyFields() {
        return MetricId_keyFields_ByWBId
    }

    get searchProviderFields(){
        return vUI_MetricId_Search_Fields
    }

    async search(requestSpec: ISearchRequestSubset): Promise<any[]> {
        const self = this

        if(!_.isEmpty(self.opts.metricIds))
            return self.opts.metricIds || []

        let wbCubeSourceId = _.toNumber(self.opts.wbCubeSourceId)
        if (wbCubeSourceId > 0) {
            //--
            let mds = new CubeSourceMetaDataService()
            let arr = await mds.getCubeSourceMetricsIds(wbCubeSourceId, self.opts.searchOptions)
            return arr
        }

        return []
    }

}


export class MetricIdSearchProfileByList
    implements  ISearchProfile {

    aSearchProvider: ISearchProvider = undefined

    profileId = "default"
    profileName = "AutoSearch Only"
    renderOptions = { ui5ResourceId: "MetricIdSearchByListProfile" }

    profileFilter: IProfileFilter[] = []

    profileDisplayFields = [
        'MetricName','GroupName','Comments','TechnicalName','MetricId'
    ]

    profileTreeIdDefault = ""
    profileTrees: ITree[] = []

    profileSortIdDefault = ""    //string;
    profileSorts: ISearchSort[] = [] //ISearchSort[];

    constructor(options: IMetricIdSearchByListCreateOptions){
        this.aSearchProvider = new MetricIdSearchByListSearchProvider(options)
    }

    get profileSearchProvider(){ return this.aSearchProvider }

}


export class CubeSourceMetricIdSearchByList
    implements  ISearch {

    opts: IMetricIdSearchByListCreateOptions
    autoSearch: boolean;
    autoSearchProfileId: string;
    renderOptions: ISearchRenderOptions;
    searchName: string;
    searchProfileIdDefault: string;
    searchProfiles: ISearchProfile[];

    constructor(options: IMetricIdSearchByListCreateOptions){
        this.opts = options || {sName: "Select"}
        this.searchName = this.opts.sName
        this.renderOptions = { ui5ResourceId: "MetricIdSearchByList"}
        this.searchProfileIdDefault = "default"
        this.searchProfiles = []
        this.autoSearch = true

        this.searchProfiles = [ new MetricIdSearchProfileByList(this.opts) ]
    }

}

